// 操作日志管理
import http from "@/jslibs/axios/http";

// 操作日志列表
export const list = (data) => http.get("/v1/cms/AdminActionLog", data);
